import { Info } from '../../Info/dump/Info';
import * as React from 'react';
import { PhoneButton } from '../../PhoneButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var CallInfo = function CallInfo(_ref) {
  var httpApi = _ref.httpApi,
    logger = _ref.logger,
    placeType = _ref.placeType,
    pageType = _ref.pageType,
    phone = _ref.phone,
    name = _ref.name,
    logoUrl = _ref.logoUrl,
    type = _ref.type,
    buttonText = _ref.buttonText,
    platformType = _ref.platformType,
    siteBlockId = _ref.siteBlockId,
    _ref$button = _ref.button,
    button = _ref$button === void 0 ? {} : _ref$button,
    onPhoneOpen = _ref.onPhoneOpen,
    isOpen = _ref.isOpen,
    realtyUserId = _ref.realtyUserId;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Info, {
      type: type,
      name: name,
      logoUrl: logoUrl
    }), /*#__PURE__*/_jsx(PhoneButton, {
      realtyUserId: realtyUserId,
      httpApi: httpApi,
      logger: logger,
      siteBlockId: siteBlockId,
      pageType: pageType,
      platformType: platformType,
      placeType: placeType,
      buttonText: buttonText,
      styles: button,
      phone: phone,
      onClick: onPhoneOpen,
      isOpen: isOpen
    })]
  });
};